import { render, staticRenderFns } from "./c-action-btn.vue?vue&type=template&id=b7b573e4&"
import script from "./c-action-btn.vue?vue&type=script&lang=js&"
export * from "./c-action-btn.vue?vue&type=script&lang=js&"
import style0 from "./c-action-btn.vue?vue&type=style&index=0&id=b7b573e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports